import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { AssetCommonService } from '../../../services/asset-common.service';

@Component({
  selector: 'thehubz-asset-export-downloads',
  templateUrl: './asset-export-downloads.component.html',
  styleUrls: ['./asset-export-downloads.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule, MatFormFieldModule],
})
export class AssetExportDownloadsComponent {
  /** Observable to get download history count  */
  assetDownloadHistoryCount$: Observable<number> = this.assetCommonService.assetDownloadHistoryCount;

  constructor(
    @Inject(MAT_DIALOG_DATA) public assetName: string,
    private dialogRef: MatDialogRef<AssetExportDownloadsComponent>,
    private assetCommonService: AssetCommonService,
  ) {}

  exportDownloads() {
    this.dialogRef.close(true);
  }
}
